import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BANNERS_FEATURE_KEY, bannersReducer } from './state+/banners.reducer';
import { BannersEffects } from './state+/banners.effects';
import { BannersFacade } from './state+/banners.facade';
import { BannersService } from './banners.service';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature(BANNERS_FEATURE_KEY, bannersReducer)],
    providers: [BannersFacade, BannersService, BannersEffects]
})
export class BannersModule {}
